export const environment = {
  apiUrl: 'https://staging.nestup.fullstackagency.it/api/v1',
  applicationId: 'd8e3f721-9b52-4c89-a936-1e4d7f8a9c05',
  redirectUrl: 'https://staging.nestup.fullstackagency.it/callback',
  meilisearch: 'https://meilisearch.staging.nestup.fullstackagency.it',
  meilisearchKey: '4ooEMV2sMpLm4wXMCgnexDifTDFmJx8yvE9PwiCh',
};
